import React from "react";
import AllDetailPatientVaccinTable from "../../../Tables/AllDetailPatientVaccinTable";
import { IUser } from "../../../../../utils/api/user/user.type";
import { IRdvs } from "../../../../../utils/api/rdvs/rdvs.type";
import { MdOutlineAddBox } from "react-icons/md";
import { NavLink } from "react-router-dom";

function Vaccins({ item, rdv }: { item: IUser; rdv?: IRdvs }) {

  return (
    <>
      {!!rdv && rdv?.status !== "annuler" && (
        <div className="add-notes-btn-content d-flex flex-r pb-4">
          <NavLink
            to={`/medecin/ajouter-vaccination/${rdv?.slug}`}
            className="add-notes-btn no-link"
            state={rdv}
          >
            <MdOutlineAddBox className="add-icon" />
            Ajouter un vaccin
          </NavLink>
        </div>
      )}
      <AllDetailPatientVaccinTable item={item} rdv={rdv} />
    </>
  );
}

export default Vaccins;
